module.exports = __webpack_public_path__ + "static/media/CAPRO_12.3f038649.png";